import { h as t } from "vue";
import "./ghl-ui.es63.js";
import { renderAvatar as r } from "./ghl-ui.es704.js";
import a from "./ghl-ui.es90.js";
const l = {
  display: "flex",
  alignItems: "center",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "24px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, f = ({ option: e }) => t(
  "div",
  {
    style: l
  },
  [
    r(e),
    t(
      "p",
      {
        style: {
          margin: 0,
          marginLeft: "8px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      },
      { default: () => e.label }
    )
  ]
), m = ({
  option: e,
  handleClose: i
}) => t(
  a,
  {
    style: {
      padding: "0 6px 0 4px"
    },
    round: !0,
    closable: !0,
    onClose: (o) => {
      o.stopPropagation(), i();
    }
  },
  {
    default: () => t(
      "div",
      {
        style: l
      },
      [
        r(e),
        t(
          "p",
          {
            style: {
              margin: 0,
              marginLeft: "8px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }
          },
          { default: () => e.label }
        )
      ]
    )
  }
);
export {
  m as renderMultipleSelectedAsAvatar,
  f as renderSingleSelectedAsAvatar
};
